export default __webpack_public_path__ + "exportPNG.png";